import { PDFDocument } from "pdf-lib";

export const getFileName = (response) => {
  const contentDisposition = response.headers["content-disposition"];
  const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const match = regex.exec(contentDisposition);
  const fileName = match && match[1].replace(/['"]/g, "")?.trim();

  return fileName;
};

/**
 * Download File obtained as response
 * @param {Object} response
 * @param {String} fileName
 *
 * @returns
 */
export const downloadFile = (response, fileName) => {
  if (!fileName) {
    fileName = getFileName(response);
  }

  const url = URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const getFileBlobUrl = (file) => {
  const documentBlob = new Blob([file.data], {
    type: file.headers["content-type"],
  });
  const fileURL = URL.createObjectURL(documentBlob);
  return fileURL;
};

export const getFileExtension = (fileName) => {
  return fileName.split(".").pop().toLowerCase();
};

export const countPagesInPDF = async (pdfFile) => {
  const pdfBytes = await pdfFile.arrayBuffer();
  const pdfDoc = await PDFDocument.load(pdfBytes);
  const numPages = pdfDoc.getPageCount();
  return numPages;
};
